<template>
  <main class="bg-white py-10">
    <div class="container mx-auto px-4">
      <h2 class="text-center text-3xl mb-2 font-bold text-yellow mt-8">
        Meet Us
      </h2>
      <hr class="h-1 bg-yellow mx-auto rounded-lg border-none w-40" />

      <div class="flex justify-center mb-10 mt-10">
        <div
          class="w-72 text-center cursor-pointer group"
          @click="openModal(chairman)"
        >
          <div
            class="bg-white shadow-lg rounded-lg overflow-hidden hover:shadow-xl transition-all duration-300"
          >
            <img
              class="w-full h-96 object-cover"
              src="../assets/images/MR MUS.png"
              alt="Dr. Musa Tarimbuka"
            />
          </div>
          <h4 class="mt-4 text-lg font-semibold text-gray-800 board-style">
            Dr. Musa Tarimbuka
          </h4>
          <p class="text-gray-600">Chairman</p>
          <p class="text-yellow text-sm mt-2 hover:underline">View Profile</p>
        </div>
      </div>

      <div class="overflow-x-auto overflow-y-hidden py-6 scroll-wrapper">
        <div class="flex gap-6 px-4 min-w-max">
          <div
            class="w-72 text-center flex-shrink-0 cursor-pointer group"
            v-for="director in directors"
            :key="director.name"
            @click="openModal(director)"
          >
            <div
              class="bg-white shadow-lg rounded-lg overflow-hidden hover:shadow-xl transition-all duration-300"
            >
              <img
                class="w-full h-96 object-cover object-top"
                :src="director.image"
                :alt="director.name"
              />
            </div>
            <h4 class="mt-4 text-lg font-semibold text-gray-800 board-style">
              {{ director.name }}
              <span v-if="director.title" class="text-base">
                {{ director.title }}</span
              >
            </h4>
            <p class="text-gray-600">{{ director.position }}</p>
            <p class="text-yellow text-sm mt-4 mb-10 hover:underline">
              View Profile
            </p>
          </div>
        </div>
      </div>
    </div>

    <transition name="modal">
      <div
        v-if="showModal"
        class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-60"
        @click.self="closeModal"
      >
        <div
          class="bg-white rounded-2xl shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto"
          v-if="selectedDirector"
        >
          <div class="flex flex-col md:flex-row">
            <div class="md:w-2/5 bg-gray-100 flex-shrink-0">
              <img
                :src="selectedDirector.image"
                :alt="selectedDirector.name"
                class="w-full h-64 md:h-full object-cover"
              />
            </div>

            <div
              class="md:w-3/5 p-8 md:p-12 md:overflow-y-auto md:max-h-[90vh] relative"
            >
              <button
                @click="closeModal"
                class="absolute top-6 right-6 w-10 h-10 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 text-gray-600 hover:text-gray-900 transition-all duration-200"
              >
                <svg
                  class="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  ></path>
                </svg>
              </button>

              <div class="mb-8 pr-12">
                <div class="inline-block mb-3">
                  <span
                    class="px-3 py-1 bg-amber-500 text-white text-xs font-semibold rounded uppercase tracking-wider"
                  >
                    {{ selectedDirector.position }}
                  </span>
                </div>
                <h3
                  class="text-2xl md:text-3xl font-bold text-gray-900 mb-2 leading-tight"
                >
                  {{ selectedDirector.name }}
                </h3>
                <span
                  v-if="selectedDirector.title"
                  class="text-base text-gray-500 font-medium"
                  >{{ selectedDirector.title }}</span
                >
              </div>

              <div class="space-y-4">
                <div class="h-1 w-16 bg-amber-500 rounded-full"></div>
                <p
                  class="text-gray-600 leading-relaxed text-xs md:text-lg text-justify"
                >
                  {{ selectedDirector.description }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </main>
</template>

<script>
export default {
  data() {
    return {
      showModal: false,
      selectedDirector: null,
      chairman: {
        name: "Dr. Musa Tarimbuka",
        position: "Chairman",
        image: require("../assets/images/MR MUS.png"),
        description:
          "Dr. Musa Tarimbuka is a Banker and Development Expert. He has held sensitive Senior Management positions across Merchant and Commercial Banks for over two decades. Notably are Gulf Bank, Nigeria Belgium Merchant Bank, Zenith Bank, and currently the Regional Bank Head covering the North Eastern States of Nigeria with Fidelity Bank. He owns multidisciplinary degrees of Doctor of Veterinary Medicine, MSc, MBA, and Ph.D. from both Nigerian and offshore Premier Universities. His other professional qualifications include HCIBN, FICM, and NVMAN. He has attended various local and offshore courses in distinguished management training institutions. He is the pioneer Chairman of Mshel Group Limited.",
      },
      directors: [

       {
          name: "Dr. Nzeribe Zerry Ihekwaba",
          position: "Non-Executive Director",
          image: require("../assets/images/Dr Nzeribe.jpeg"),
          description: `Dr. Nzeribe “Zerry” Ihekwaba, Ph.D., P.E., ICMA-CM, is a licensed Professional Engineer in the United States and Nigeria. He holds a Ph.D. in Civil Engineering from Queen’s University in Kingston, Ontario, Canada, and he is a public sector executive, and strategic leader with over 35 years of international experience in infrastructure development, corporate governance, municipal administration, and organisational leadership. 

A credentialed city manager by the International City/County Management Association (ICMA), a member of the American Society of Civil Engineers (ASCE), and several other international professional organizations, he brings to the Board a wealth of global experience, sound governance insight, and a proven record of delivering transformational results across both the public and private sectors. `,
        },
        {
          name: "Sam Hart",
          title: "mni",
          position: "Independent Director",
          image: require("../assets/images/sam.jpeg"),
          description: `Sam Ifeanyi Hart is a legal practitioner and public policy professional with strong expertise in leadership development and strategic governance. He holds a Bachelor of Laws (LLB) and a Master of Laws (LLM) in Environmental Law from Abia State University, as well as a Barrister at Law (BL) qualification from the Nigerian Law School.  

          He is currently pursuing doctoral research in Climate Change Governance and in Leadership and Strategic Studies. Sam is a Distinguished Member of the National Institute (mni), following his completion of the Senior Executive Course at the National Institute for Policy and Strategic Studies (NIPSS), Kuru, where he served as Course Secretary-General. He has also completed executive leadership programs at the GOTNI Leadership Centre and the School of Politics, Policy and Governance.  

          He is a member of several professional bodies, including the Chartered Institute of Directors (IoD), the Nigerian Institute of Chartered Arbitrators, the Nigerian Bar Association, the Nigerian Institute of Public Relations, and the Nigerian Environmental Society.  

          Sam is engaged in private legal practice and provides advisory and training services to public and private institutions. He also sits on the boards of corporate and non-governmental organizations. He is married to Chika Hart, and they are blessed with four children.`,
        },
        {
          name: "Arc. Lisa B. Mshelia",
          position: "Non-Executive Director",
          image: require("../assets/images/MRS LISA MSHELIA.png"),
          description: `As a seasoned architect and property valuation advisor, Lisa has established a reputation as an adaptable, flexible, versatile, and results-driven professional. With a degree in architecture and over four years of experience working in teams on various projects, she has honed her skills in design and project supervision, as well as customer service and marketing.  

          As a natural leader, she has played leadership roles in various capacities and demonstrated a knack for guiding teams to deliver results. Her leadership skills have been further honed through years of experience in the oil and gas industry, where she currently works as a property valuation advisor. In this role, she has gained a deeper understanding of the built environment and its impact on property valuation, enhancing her knowledge of architecture beyond traditional design.  

          Beyond her passion for sustainable architecture, Lisa has a keen interest in art and business development. She is committed to ongoing learning and expanding her knowledge of business development, believing that understanding the business side of architecture is essential for success. She is poised to make a significant impact in the industry and the Nigerian economy.`,
        },
        {
          name: "Folahanmi Ogunbodede",
          position: "Non-Executive Director",
          image: require("../assets/images/MR FOLA.png"),
          description: `Folahanmi is a seasoned professional with about 15 years of experience in the financial services industry, focused on:

          - Management & Leadership  
          - Banking  
          - Information Technology (Audit & Security)  
          - Business Analysis & Advisory  
          - Pension Advisory  
          - Business Continuity Management  
          - Data Privacy  
          - Governance, Risk Management, and Compliance  

          He holds a B.Sc. (Hons) in Computer Science from Adekunle Ajasin University and a Master's Degree in Information Security from the University of Abuja.  

          Folahanmi is a professional member of the Information Systems Audit Control Association (ISACA) and the Professional Evaluation & Certification Board (PECB).  

          He has worked with Skye Bank (now defunct), Sigma Pensions, and FCMB Pensions Limited in various capacities.  
          He has also attended several courses from:  
          - FITC Nigeria  
          - Lagos Business School  
          - International Compliance Association (ICA), United Kingdom  
          - Compliance LLC, United States  
          - Harvard Business School  
          - Koenig Solutions, India.`,
        },
        {
          name: "Onyilokwu Andrew Ochofie",
          title: "FCA, MBA",
          position: "Non-Executive Director",
          image: require("../assets/images/andrew.png"),
          description: `Onyilokwu Andrew Ochofie, FCA, is a Chartered Accountant and seasoned banking professional with over 26 years of experience in Nigeria's financial services sector.  

          He has held senior executive roles including Chief Financial Officer at Fidelity Bank Plc and Unity Bank Plc, Chief Internal Auditor at International Trust Bank Plc and Unity Bank Plc, Executive Director, Finance & Benefits Administration at Trustfund Pensions Limited, and currently serves as Chairman/Chief Executive at FSG Work Solutions International Limited.  

          A Fellow of the Institute of Chartered Accountants of Nigeria (ICAN), he brings deep expertise in financial management, corporate finance, internal audit, risk oversight, and banking operations, strengthened by executive training from leading global institutions.`,
        },
        {
          name: "Chief Joe-Kyari Gadzama",
          title: "SAN",
          position: "Independent Director",
          image: require("../assets/images/jk.png"),
          description: `Joe-Kyari Gadzama, SAN, is the Founding Principal Partner of J-K Gadzama LLP, Abuja, and one of Nigeria's most accomplished legal minds. With over three decades of distinguished professional experience, he is a renowned lawyer, arbitrator, and academic with expertise spanning public law, arbitration, and governance.  

          Conferred with the rank of Senior Advocate of Nigeria in 1998, he has held several high-profile roles, including Lead Counsel to the Independent National Electoral Commission (INEC), Legal Consultant to the Bureau of Public Enterprises (BPE), and Chairman of the EFCC Legal Team.  

          Beyond legal practice, Joe-Kyari Gadzama, SAN, is a respected part-time lecturer at Nile University of Nigeria and an internationally recognised authority in arbitration and dispute resolution, known for his enduring reputation of excellence, integrity, and leadership within and beyond Nigeria's legal community.`,
        },
      ],
    };
  },
  methods: {
    openModal(director) {
      this.selectedDirector = director;
      this.showModal = true;
      document.body.style.overflow = "hidden";
    },
    closeModal() {
      this.showModal = false;
      this.selectedDirector = null;
      document.body.style.overflow = "";
    },
  },
  beforeUnmount() {
    document.body.style.overflow = "";
  },
};
</script>

<style scoped>
.board-style {
  font-family: Caveat;
}

.text-yellow {
  color: #f59e0b;
}

.bg-yellow {
  background-color: #f59e0b;
}

.scroll-wrapper {
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
}

.scroll-wrapper::-webkit-scrollbar {
  height: 6px;
}

.scroll-wrapper::-webkit-scrollbar-track {
  background: transparent;
}

.scroll-wrapper::-webkit-scrollbar-thumb {
  background: #f59e0b;
  border-radius: 10px;
}

.modal-enter-active,
.modal-leave-active {
  transition: all 0.3s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
  transform: scale(0.95);
}
</style>
